var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMenu = function SvgIconMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1899 -1279)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M588,173v4a4,4,0,0,1-3,3.858V187a1,1,0,0,1-2,0v-6.142A4,4,0,0,1,580,177v-4a1,1,0,0,1,2,0v4a2,2,0,0,0,4,0v-4a1,1,0,0,1,2,0Zm-4,5a1,1,0,0,0,1-1v-4a1,1,0,0,0-2,0v4A1,1,0,0,0,584,178Zm10.384,1.938a3.191,3.191,0,0,1-1.384.885V187a1,1,0,0,1-2,0v-6.178a3.145,3.145,0,0,1-2.181-3.37c.026-.234.048-.474.071-.717.172-1.885.434-4.735,3.11-4.735s2.937,2.85,3.11,4.735c.023.243.045.483.071.717A3.206,3.206,0,0,1,594.384,179.938Zm-1.192-2.268c-.026-.245-.049-.5-.073-.752-.211-2.291-.451-2.918-1.119-2.918s-.908.627-1.119,2.918c-.024.255-.047.507-.073.752a1.188,1.188,0,0,0,.3.934,1.236,1.236,0,0,0,1.79,0A1.188,1.188,0,0,0,593.192,177.67Z",
    transform: "translate(1323 1111)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-menu.55f361e1.svg";
export { ForwardRef as ReactComponent };